import cancelImage from "../assets/images/cancel.png";
import editImage from "../assets/images/edit.png";
import {
  useChangeStatusOrPriorityOrTextMutation,
  useDeleteTodoMutation,
} from "../features/api/apiSlice";
import { Circles } from "react-loader-spinner";
export default function Todo({ todo, handleModalOpen }) {
  const { text, id, completed, color } = todo;
  const [deleteTodo] = useDeleteTodoMutation();
  const [changeMultipleTodoStatus, { isLoading }] =
    useChangeStatusOrPriorityOrTextMutation();

  const handleStatusOrPriorityOrTextChange = ({ id, data, changeProperty }) => {
    changeMultipleTodoStatus({
      id,
      body: {
        [changeProperty]: data,
      },
    });
  };

  const handleDelete = (id) => {
    deleteTodo(id);
  };

  return (
    <>
      <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
        {isLoading ? (
          <Circles
            height="20"
            width="20"
            color="#4fa94d"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        ) : (
          <div
            className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 hover:border-green-500 ${
              completed && "border-green-500 focus-within:border-green-500"
            }`}
          >
            <input
              type="checkbox"
              checked={completed}
              onChange={() =>
                handleStatusOrPriorityOrTextChange({
                  id,
                  data: !completed,
                  changeProperty: "completed",
                })
              }
              className="opacity-0 absolute rounded-full"
            />
            {completed && (
              <svg
                className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            )}
          </div>
        )}

        <div
          onClick={() => handleModalOpen(true, text, id)}
          className={`select-none flex-1 ${completed && "line-through"}`}
        >
          {text}
        </div>

        <div
          className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
            color === "green" && "bg-green-500"
          }`}
          onClick={() =>
            handleStatusOrPriorityOrTextChange({
              id,
              data: "green",
              changeProperty: "color",
            })
          }
        ></div>

        <div
          className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
            color === "yellow" && "bg-yellow-500"
          }`}
          onClick={() =>
            handleStatusOrPriorityOrTextChange({
              id,
              data: "yellow",
              changeProperty: "color",
            })
          }
        ></div>

        <div
          className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
            color === "red" && "bg-red-500"
          }`}
          onClick={() =>
            handleStatusOrPriorityOrTextChange({
              id,
              data: "red",
              changeProperty: "color",
            })
          }
        ></div>

        <img
          src={cancelImage}
          className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
          alt="Cancel"
          onClick={() => handleDelete(id)}
        />
        <img
          src={editImage}
          className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
          alt="Edit"
          onClick={() => handleModalOpen(true, text, id)}
        />
      </div>
    </>
  );
}
